import { KONKURSY,UCZESTNIK,REGULAMIN,START,OPCJE,PYTANIA } from "./typyDanych";
export const startDane = {
    [OPCJE]: 
     {},
    [PYTANIA]: [

    ],
    [KONKURSY]: [
        
    ],
    [REGULAMIN]: [
        {lp:1,tekst:"Test przeznaczony jest dla Kandydatów starających się o zatrudnienie w Komendzie Miejskiej Policji w Łodzi;"},
        {lp:2,tekst:"Test Kandydat musi rozwiązać samodzielnie bez pomocy osób trzecich;"},
        {lp:3,tekst:"Każdy Kandydat może rozwiązać niniejszy Test tylko 1 raz;"},
        {lp:4,tekst:"Test dla Kandydatów dostępny jest tylko przez 24 godziny;"},
        {lp:5,tekst:"Test obejmuje 20 pytań zamkniętych to znaczy, że na każde zadane pytanie przypada tylko 1 prawidłowa odpowiedź"},
        {lp:6,tekst:"Test trwa 10 minut"},
        {lp:7,tekst:"Na odpowiedź na każde pytanie Kandydat ma maksymalnie 30 sekund;"},
        {lp:8,tekst:"Po upływie 30 sekund Kandydat automatycznie otrzymuje kolejne pytanie, bez względu na to czy udzielił odpowiedzi na poprzednie pytanie czy też nie;"},
        {lp:9,tekst:"W przypadku pytania w których Kandydat nie wybrał odpowiedzi, traktowane będą jako pytanie na które nie udzielono odpowiedzi;"},
        {lp:10,tekst:"Kandydat nie ma możliwości powrotu do poprzedniego pytania, pomimo faktu, że czas na rozwiązanie Testu jeszcze nie upłynął;"},
        {lp:11,tekst:"Kandydat ma możliwość dokonania korekty udzielonej odpowiedzi na pytanie w ramach limitu czasowego dla danego pytania"},
        {lp:12,tekst:"Kandydat na starcie Testu otrzymuje 20 punktów;"},
        {lp:13,tekst:"W przypadku udzielenia błędnej odpowiedzi Kandydatowi zostaje odjęty 1 punkt;"},
        {lp:14,tekst:"W przypadku nie udzielenia odpowiedzi na zadane pytanie Kandydat uzyskuje 0 punktów;"},
        {lp:15,tekst:"Maksymalną ilość punktów jaką może uzyskać Kandydat rozwiązując Test to 40 punktów;"},
        {lp:16,tekst:"Po zakończeniu rozwiązywania Testu Kandydat otrzyma informację o ilości uzyskanych w Teście punktów;"},
        {lp:17,tekst:"Test jest przeznaczony wyłącznie dla Kandydatów i jego rozpowszechnianie i udostępnianie w jakiejkolwiek formie innym Kandydatom lub osobom trzecim jest zabronione;"},
        {lp:18,tekst:"Warunkiem przystąpienia do Testu jest akceptacja niniejszego regulaminu;"}
      ],
      [START]: [
        {lp:1,tekst:"Wybór pola START jest jednoznaczny z rozpoczęciem Testu;"},
        {lp:2,tekst:"W przypadku problemów technicznych (przerwanie działania Testu w trakcie jego trwania) ponowne zalogowanie się na stronę pozwoli na kontunuację Testu;"},
        {lp:3,tekst:"Jeżli jednak Kandydat w zaistniałym powyżej przypadku nie zaloguje się ponownie w trakcie czasu trwania konkursu to wówczas Kandydat straci szansę na kontynuację Testu.;"},
        {lp:5,tekst:"Wybór pola REZYGNACJA nie przekreśla możliwości rozwiązania Testu w późniejszym terminie, pod warunkiem że Kandydat dokona tego w wyznaczonym do tego czasie."},
      ],
    [UCZESTNIK]: 
        {}
}